import { Tooltip } from '@chakra-ui/react';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import styled from 'styled-components';

export const CustomTooltip = styled(Tooltip)`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  max-width: 270px;
  width: 100%;
  background: ${(props) => props.theme.colors['neutral-10']};
  padding: 16px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors['neutral-20']};
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.07);
`;

export const CustomInfoOutlinedIcon = styled(InfoOutlined)`
  color: ${(props) => props.theme.colors['neutral-40']};
  font-size: 13px !important;
  margin-left: 4px;
`;
